module.exports = __webpack_public_path__ + "static/media/splash.996a9c52.jpg";